import { Box } from "@mui/material";

import { mono } from "../../theme/colors";
import ImageIcon from "../icons/social/ImageIcon";

export enum IMAGE_SIZE {
  SQUARE,
  WIDE,
  PANORAMIC,
}

const imageSettings = {
  [IMAGE_SIZE.SQUARE]: {
    width: 100,
    height: 100,
    iconSize: 48,
  },
  [IMAGE_SIZE.WIDE]: {
    width: 180,
    height: 112.5,
    iconSize: 56,
  },
  [IMAGE_SIZE.PANORAMIC]: {
    width: 180,
    height: 50,
    iconSize: 32,
  },
};

type Props = {
  alt: string;
  imageSize: IMAGE_SIZE;
  imageUri?: string;
  scale?: number;
};

type SkeletonProps = {
  imageSize: IMAGE_SIZE;
  scale: number;
};

const Image = ({ alt, imageSize, imageUri, scale = 1 }: Props) => {
  const { width, height } = imageSettings[imageSize];

  if (!imageUri) {
    return <ImageSkeleton imageSize={imageSize} scale={scale} />;
  }

  return (
    <Box
      borderRadius={4}
      width={width * scale}
      height={height * scale}
      overflow="hidden"
    >
      <img src={imageUri} alt={alt} style={{ width: "100%" }} />
    </Box>
  );
};

const ImageSkeleton = ({ imageSize, scale }: SkeletonProps) => {
  const { width, height, iconSize } = imageSettings[imageSize];

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      border="1px dotted"
      borderColor="mono.grey.1"
      borderRadius={4}
      width={width * scale}
      height={height * scale}
    >
      <ImageIcon width={iconSize} height={iconSize} fill={mono.grey["1"]} />
    </Box>
  );
};

export default Image;
